// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import Input from '@mui/material/Input';
import InputBase from '@mui/material/InputBase';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

export const StyledFormLabel = styled(FormLabel)({
  fontSize: '0.75rem',
  marginBottom: '0.25rem',
});

export const BottomBorderInput = styled(Input)(({ theme }) => ({
  margin: '0.6rem 0',
  '&:hover:not(.Mui-disabled)': {
    '&:before': {
      borderBottom: 0,
    },
  },
  '&:before': {
    borderBottom: `1px solid ${COLORS.BORDER_MAIN} !important`,
  },
  '&:after': {
    borderBottom: `2px solid ${theme.mainColor} !important`,
  },
}));

export const FullBorderInput = styled(InputBase)(({ theme }) => ({
  padding: '15.5px 14px',
  borderRadius: 4,
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${COLORS.BORDER_MAIN}`,
  fontSize: 14,
  transition: theme.transitions.create(['border-color', 'box-shadow']),
  '&:focus': {
    borderRadius: 4,
    boxShadow: `0 0 0 2px ${theme.mainColor}`,
  },
}));

export const NoBorderInput = styled(Input)({
  height: 'calc(100% - 13px)',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '1rem',
  '&:hover:not(.Mui-disabled)': {
    '&:before': {
      borderBottom: 0,
    },
  },
  '&:before': {
    borderBottom: 'none !important',
  },
  '&:after': {
    borderBottom: 'none !important',
  },
});
